"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _FormField = _interopRequireDefault(require("../../mixins/FormField"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _map = _interopRequireDefault(require("lodash/map"));

var _mobxReact = require("mobx-react");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _clientErrorLogger = _interopRequireDefault(require("../../../util/clientErrorLogger"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var CustomSelect = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomSelect, _React$Component);

  var _super = _createSuper(CustomSelect);

  function CustomSelect() {
    _classCallCheck(this, CustomSelect);

    return _super.apply(this, arguments);
  }

  _createClass(CustomSelect, [{
    key: "handleSelectChange",
    value: function handleSelectChange(e) {
      // save data more aggressively, since select should only have discrete changes
      if (!this.inputElement) {
        _clientErrorLogger.default.notify("No input element defined for form field", "error");

        return;
      }

      this.value = this.inputElement.value;
      this.updateBackingValue(true);

      if ((0, _isFunction.default)(this.props.onChange)) {
        this.props.onChange(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fieldName = _this$props.fieldName,
          label = _this$props.label,
          disabled = _this$props.disabled,
          disablePlaceholder = _this$props.disablePlaceholder,
          name = _this$props.name,
          id = _this$props.id;
      var placeholderValue = (0, _isUndefined.default)(this.props.placeholderValue) ? "" : this.props.placeholderValue;
      var placeholderOption = !(0, _isUndefined.default)(this.props.placeholder) && !(0, _isNull.default)(this.props.placeholder) ? (0, _map.default)([this.props.placeholder], function (placeholder) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: placeholder,
          value: placeholderValue,
          disabled: disablePlaceholder,
          default: true
        }, placeholder);
      }) : undefined;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames("custom-select")
      }, !(0, _isEmpty.default)(label) && /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: fieldName
      }, label), /*#__PURE__*/_react.default.createElement("select", {
        id: id || fieldName,
        name: name || fieldName,
        ref: this.setInputRef,
        value: this.readValue(),
        onChange: this.handleSelectChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        "aria-label": label || this.props.placeholder,
        disabled: disabled
      }, placeholderOption, (0, _map.default)(this.props.options, function (option) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })), this.renderErrors());
    }
  }]);

  return CustomSelect;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(_react.default.Component)]),
  placeholder: _propTypes.default.string,
  placeholderValue: _propTypes.default.string,
  fieldName: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  disablePlaceholder: _propTypes.default.bool,
  options: _mobxReact.PropTypes.arrayOrObservableArrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    value: _propTypes.default.any.isRequired
  })).isRequired
}), _class2), (_applyDecoratedDescriptor(_class.prototype, "handleSelectChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleSelectChange"), _class.prototype)), _class);

var _default = (0, _FormField.default)(CustomSelect);

exports.default = _default;